const uz = {
  app: {
    name: "Pasayish Nuqtasi Kalkulyatori",
    shortName: "PN Kalkulyator",
    subtitle: "Parvoz pasayishini taxminiy rejalashtirish vositasi",
    badge: "Frontend kalkulyator",
    disclaimer:
      "Ushbu kalkulyator faqat o'quv va taxminiy rejalashtirish maqsadlari uchun mo'ljallangan. Operatsion aviatsiya foydalanishi uchun sertifikatlanmagan.",
  },
  language: {
    label: "Til",
    uzbek: "O'zbek",
    russian: "Русский",
    english: "English",
  },
  nav: {
    calculator: "Kalkulyator",
    results: "Natijalar",
    info: "Ma'lumot",
  },
  form: {
    title: "Pasayish parametrlari",
    altitudeSection: "Balandlik",
    speedSection: "Tezlik va shamol",
    profileSection: "Profil",
    startAltitude: "Boshlang'ich balandlik",
    endAltitude: "Yakuniy balandlik",
    groundSpeed: "Yerga nisbatan tezlik",
    finalSpeed: "Yakuniy tezlik",
    wind: "Shamol",
    glideSlope: "Glissada burchagi",
    verticalSpeed: "Vertikal tezlik",
    startAltitudePlaceholder: "Masalan: 30 000",
    endAltitudePlaceholder: "Masalan: 10 000",
    groundSpeedPlaceholder: "Masalan: 320",
    finalSpeedPlaceholder: "Masalan: 250",
    windPlaceholder: "Masalan: 0",
    glideSlopePlaceholder: "Masalan: 3",
    verticalSpeedPlaceholder: "Masalan: 1 500",
    calculate: "Hisoblash",
    reset: "Tozalash",
    fillExample: "Namuna to'ldirish",
    helperProfile:
      "Glissada va vertikal tezlik bog'langan — birini o'zgartirish ikkinchisini yangilaydi.",
  },
  units: {
    feet: "ft",
    knots: "kts",
    degrees: "°",
    fpm: "fpm",
    nauticalMiles: "NM",
    minutes: "min",
  },
  results: {
    title: "Hisoblangan natijalar",
    empty: "Natijalarni ko'rish uchun qiymatlarni kiriting.",
    verticalSpeed: "Vertikal tezlik",
    topOfDescent: "Pasayishni boshlash nuqtasi",
    estimatedTime: "Taxminiy vaqt",
    approximate: "Taxminiy hisob-kitob",
  },
  info: {
    title: "Hisoblash ma'lumotlari",
    howItWorks: "Qanday ishlaydi",
    description:
      "Pasayishni boshlash masofasi balandlik farqi, glissada burchagi va o'rtacha yer tezligiga qarab hisoblanadi. Tezlik o'zgarishi va shamol tuzatmalari qo'shimcha omil sifatida qo'llanadi.",
    formulaLabel: "Asosiy formula",
    formula: "masofa = balandlik farqi × tan(glissada) × tezlik omili",
    safetyTitle: "Faqat o'quv va rejalashtirish uchun",
    safetyText:
      "Haqiqiy parvozda havo kemasi turi, parvoz profili, atmosfera sharoitlari, ATC ko'rsatmalari va rasmiy navigatsion ma'lumotlar ustuvor hisoblanadi.",
  },
  validation: {
    required: "Bu maydon majburiy.",
    invalidNumber: "To'g'ri raqam kiriting.",
    invalidAltitude:
      "Yakuniy balandlik boshlang'ich balandlikdan past bo'lishi kerak.",
    startAltitudeTooLow:
      "Boshlang'ich balandlik yakuniy balandlikdan yuqori bo'lishi kerak.",
    invalidSpeed: "Tezlik musbat qiymat bo'lishi kerak.",
    invalidGlideSlope: "Glissada burchagi 0 dan katta bo'lishi kerak.",
    invalidVerticalSpeed: "Vertikal tezlik musbat qiymat bo'lishi kerak.",
  },
  footer: {
    text: "Pasayish Nuqtasi Kalkulyatori · Taxminiy pasayish rejalashtirish vositasi",
    version: "Versiya",
  },
  status: {
    ready: "Tayyor",
    calculating: "Hisoblanmoqda",
    invalid: "Ma'lumotlarni tekshiring",
  },
};

export default uz;
